<template>
  <div class="birth-date-breakdown">
    <slot />

    <div
      v-for="(result, name) in results"
      :key="name"
      class="birth-date-breakdown__row"
    >
      <span
        v-for="(number, key) in result"
        :key="key"
        :class="['birth-date-breakdown__number', { 'birth-date-breakdown__number--comma': number === ',' }]"
      >
        <i>{{ number }}</i>
      </span>
      <span class="birth-date-breakdown__number-label">{{ $t(`birthDateBreakdown.rowsNames.${name}`) }}</span>
    </div>

    <button
      class="button birth-date-breakdown__next-section-button"
      @click="changeSectionForward"
    >
      <span>{{ $t('birthDateBreakdown.nextSectionButton') }}</span>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'BirthDateBreakdown',
  props: {
    nextSectionButtonLabel: { type: String, default: '' },
  },
  computed: {
    ...mapState([
      'birthDate',
      'currentDate',
    ]),
    results() {
      const keys = ['seconds', 'minutes', 'hours', 'days', 'weeks', 'months']

      return keys.reduce((object, key) => ({ ...object, [key]: this.numberWithCommas(this.currentDate.diff(this.birthDate, key)).split('') }), {})
    },
  },
  methods: {
    ...mapActions([
      'changeSectionForward',
    ]),
    numberWithCommas(number) {
      // 10000 => 10,000
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
</script>
